import React, { useState, useEffect } from "react";
import { SearchNangCao } from "./SearchNangCao";
import { useSelector, useDispatch } from "react-redux";
import {
  getListDuNoChoVay,
  updateDataSearch,
} from "../../../../actions/DuNoChoVay";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { ChoVayCombo } from "constants/choVayConst";
import { formatDayMonth } from "utils/formatDate";
import { currentDate } from "utils/formatDate";
import { convertDate } from "utils/formatDate";
export const SearchBarDesktop = () => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchDuNoChoVay);

  const [dataCombo, setdataCombo] = useState(ChoVayCombo.KieuVayCombo1);

  const [dataTrangThai, setdataTrangThai] = useState(
    ChoVayCombo.TinhTrangCombo
  );

  const updateState = (field, value) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: value,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const updateDropdown = (field) => (e) => {
    //alert("tuty");
    // console.log(e.target.value);
    updateState(field, e.target.value);
  };

  const onChangeDate = (field) => (evt) => {
    updateState(field, formatDayMonth(evt));
    console.log(evt);
  };

  const onSearch = () => {
    dispatch(getListDuNoChoVay(dataSearch));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: event,
        })
      );
      dispatch(getListDuNoChoVay(dataSearch));
    }
  }; //sự kiện tìm kiếm enter

  // convert sự kiện tìm kiếm từ ngày đến ngày
  var dateFrom = currentDate();
  if (dataSearch.dateFrom === "01/01/2001") dateFrom = "";
  else dateFrom = dataSearch.dateFrom;
  var dateTo = currentDate();
  if (dataSearch.dateTo === "01/01/4000") dateTo = "";
  else dateTo = dataSearch.dateTo;
  dateTo = convertDate(dateTo);
  dateFrom = convertDate(dateFrom);
  return (
    <>
      <div className="search-new hidden-mobile-main show-table-main">
        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Từ ngày</label>
          <DateTimePicker
            value={dateFrom}
            onChange={onChangeDate("dateFrom")}
            placeholder="Từ ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Đến ngày</label>
          <DateTimePicker
            value={dateTo}
            onChange={onChangeDate("dateTo")}
            placeholder="Đến ngày"
            name="dateFrom"
          ></DateTimePicker>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Kiểu vay</label>
          <select
            name="kho"
            className="selectBox form-control input-sm"
            value={dataSearch.kieuVay}
            onChange={updateDropdown("kieuVay")}
          >
            {dataCombo &&
              dataCombo.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>

        <div className="input-sm-new input-new-18">
          <label className="font-color-default font-bold">Tình trạng</label>
          <select
            name="kho"
            className="selectBox form-control input-sm"
            value={dataSearch.tinhTrang}
            onChange={updateDropdown("tinhTrang")}
          >
            {dataTrangThai &&
              dataTrangThai.map((item, idx) => (
                <option key={"objComboStore1" + idx} value={item.value}>
                  {item.label}
                </option>
              ))}
          </select>
        </div>

        <div className="input-sm-new input-new-18 search-main-new">
          <button
            type="submit"
            className="btn btn-info-new btn-seach-ds"
            onClick={onSearch}
          >
            <i className="la la-search"></i>
            <span> &nbsp; Tìm kiếm</span>
          </button>
        </div>
      </div>
    </>
  );
};
